import TableAnchorScrollLink from '../table-anchor-scroll-link/table-anchor-scroll-link';
import './resume-table.scss';

export default function ResumeTable() {
    return (
        <div className="resume-table" data-testid="resume-table">
            <h2>QUADRO RESUMO</h2>
            <tbody className="resume-table-tbody">
                <tr className="colored-content">
                    <td>
                        <b>Agente de tratamento</b>
                    </td>
                    <td>
                        Agente de tratamento AmBev S.A. <br /> CNPJ:
                        07.526.557/0001-00
                        <br /> Endereço: Rua Dr. Renato Paes de Barros, 1017, 3º
                        andar, na cidade de São Paulo/SP
                    </td>
                </tr>
                <tr>
                    <td>
                        <b>Papel no tratamento</b>
                    </td>
                    <td>Controladora</td>
                </tr>
                <tr className="colored-content">
                    <td>
                        <b>Natureza dos dados tratados</b>
                    </td>
                    <td className="line-table-with-button">
                        Dados pessoais fornecidos pelo usuário e/ou coletados
                        automaticamente.
                        <TableAnchorScrollLink elementId="collected-information" />
                    </td>
                </tr>
                <tr>
                    <td>
                        <b>Finalidade como controladora</b>
                    </td>
                    <td className="line-table-with-button">
                        <div>
                            <p>
                                Dados de navegação e viabilidade das
                                funcionalidades do App; Cadastro no App e
                                utilização do App pelas empresas e seus
                                gestores.
                            </p>
                            <p>Base legal: Legítimo interesse</p>
                            <p>
                                Eventual envio de comunicação relacionada à
                                utilização das funcionalidades do App e à
                                conteúdos informativos relacionados ao tema.
                            </p>
                            <p>Base legal: Consentimento do titular.</p>
                        </div>
                        <TableAnchorScrollLink elementId="used-information" />
                    </td>
                </tr>
                <tr className="colored-content">
                    <td>
                        <b>Compartilhamento</b>
                    </td>
                    <td className="line-table-with-button">
                        Operadores e fornecedores de serviços essenciais para o
                        funcionamento da plataforma. Parceiros fornecedores de
                        serviços, produtos e conteúdos adicionais.
                        <TableAnchorScrollLink elementId="shared-data" />
                    </td>
                </tr>
                <tr>
                    <td>
                        <b>Proteção de dados</b>
                    </td>
                    <td className="line-table-with-button">
                        Medidas de segurança, técnicas e administrativas
                        adequadas.
                        <TableAnchorScrollLink elementId="data-security" />
                    </td>
                </tr>
                <tr className="colored-content">
                    <td>
                        <b>Seus direitos</b>
                    </td>
                    <td className="line-table-with-button">
                        Confirmação da existência de tratamento, acesso,
                        correção, etc.
                        <TableAnchorScrollLink elementId="your-rights" />
                    </td>
                </tr>
                <tr>
                    <td>
                        <b>Contato</b>
                    </td>
                    <td>E-mail: dataprivacy@ambev.com.br</td>
                </tr>
            </tbody>
        </div>
    );
}
